import { useEffect, FunctionComponent } from 'react';
import { subscribeVisibilityChange } from 'src/modules/appLifecycle';
import { disarmRenderProbe, RENDER_SURVIVAL_MS } from 'src/modules/boot/renderHealth';

type Props = { survivalMs?: number };

/** Double rAF proves a frame was produced; passive effects flush child-first, so a first-commit disarm could precede a sibling's throw. */
const RenderHealthProbe: FunctionComponent<Props> = ({ survivalMs = RENDER_SURVIVAL_MS }) => {
  useEffect(() => {
    let painted = false;
    let timer: ReturnType<typeof setTimeout> | undefined;
    let frame2 = 0;

    const onHide = () => {
      if (painted) disarmRenderProbe();
    };

    const frame1 = requestAnimationFrame(() => {
      frame2 = requestAnimationFrame(() => {
        painted = true;
        timer = setTimeout(disarmRenderProbe, survivalMs);
      });
    });

    window.addEventListener('pagehide', onHide);
    const unsubscribeVisibility = subscribeVisibilityChange(state => {
      if (state === 'hidden') onHide();
    });

    return () => {
      cancelAnimationFrame(frame1);
      cancelAnimationFrame(frame2);
      clearTimeout(timer);
      window.removeEventListener('pagehide', onHide);
      unsubscribeVisibility();
    };
  }, [survivalMs]);

  return null;
};

export default RenderHealthProbe;
